<template>
    <div class="hero-container">
      <div class="grid wrap">
          <div class="col col-size-3 purple">
            <h1 class="title"><span v-html="title"></span></h1>
          </div>
          <div class="col col-size-9">
            <img class="img" :alt="altText" :src="require(`../assets/${imageUrl}`)">
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    title: String,
    imageUrl: String,
    altText: String
  }
}
</script>

<style scoped lang="scss">
    .hero-container {
        position: relative;
        margin-top: 80px;

      .purple {
        height: 450px;
        position: relative;
        background-color: #988ABD;
        padding: 0 20px;
        display: flex;
        align-items: flex-end;
        min-width: 400px;
        max-width: 400px;
        width: 400px;
      }
      .title {
        font-size: 3.125rem;
        color: #FFF;
        text-align: left;
        font-weight: 100;
      }
      .overlay {
        background-color: rgba(0,0,0,0.2);
        width: 100%;
        height: 450px;
        position: absolute;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
      }
      img {
        object-fit: cover;
        object-position: center 31%;
        width: 100%;
        height: 450px;
      }
    }
    @media only screen and (max-width: 768px) {
      .hero-container {
        .purple {
          height: auto;
          order: 2;
          min-width: auto;
          max-width: initial;
          width: auto;
          margin-top: -6px;
        }
        .title {
          font-size: 2.5rem;
        }
        .overlay {
          order: 1;
          height: 300px;
        }
        img {
          order:1;
          height: 300px;
        }
      }
    }
</style>
